import {memo} from 'react'
import {Timeline} from '@primer/react'
import type {TimelineItem} from '../../../page-data/payloads/timeline'
import {TimelineItemBadge} from './TimelineItemBadge'
import {TimelineItemAction} from './TimelineItemAction'

export const TimelineEvent = memo(function TimelineEvent({item}: {item: TimelineItem}) {
  return (
    <Timeline.Item condensed>
      <TimelineItemBadge item={item} />
      <TimelineItemAction item={item} />
    </Timeline.Item>
  )
})
